<template>
  <b-card
    :title="this.translations.title[this.lang]"
    @cancel="$emit('cancel')"
    :submitBtn="false"
    :disabled="false"
    :cancel-text="{ el: 'Κλείσιμο', en: 'Close', it: 'Chiudi' }"
  >
    <!-- <v-col cols="12" sm="4" ml="auto" class="pa-0">
                                <b-search-field
                                    v-model="search"
                                ></b-search-field>
                            </v-col> -->
    <ExportLinks
      export-key="company-customer-transactions"
      :filters="{ user_id: transDialogUserId, ...filtersData }"
    />

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="userTransactions"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= userTransItemsLength ? page * 12 : userTransItemsLength
        } ${translations.paginationText[lang]} ${userTransItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="userTransItemsLength"
      class="b-outlined"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Search" class="mx-4"></v-text-field>
      </template>
      <template v-slot:no-data>
        <span v-if="!loading" v-text="translations.noData[lang]"></span>
      </template>

      <template v-slot:item.transaction_id="{ item }"> # {{ item.transaction_id }} </template>

      <template v-slot:item.total_price="{ item }">
        {{
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
          }).format(item.total_price)
        }}
      </template>

      <template v-slot:item.total_amount="{ item }">
        {{
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
          }).format(item.total_amount)
        }}
      </template>

      <template v-slot:item.payment_data="{ item }">
        <div v-if="item.payment_data && item.payment_data.custom_reason" class="text-truncate">
          <div
            v-if="item.payment_data.custom_reason.length > 30"
            class="text-truncate"
            style="max-width: 200px"
          >
            <v-tooltip top style="max-width: 400px">
              <template v-slot:activator="{ on, attrs }">
                <div
                  style="
                    max-width: 400px;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    cursor: pointer;
                  "
                  v-bind="attrs"
                  v-on="on"
                  class="text-truncate"
                >
                  {{ item.payment_data.custom_reason }}
                </div>
              </template>
              <div style="max-width: 400px; white-space: pre-wrap; word-wrap: break-word">
                {{ item.payment_data.custom_reason }}
              </div>
            </v-tooltip>
          </div>
          <div v-else>{{ item.payment_data.custom_reason }}</div>
        </div>
        <span v-else>-</span>
      </template>

      <template v-slot:item.delivery_fee="{ item }">
        {{
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
          }).format(item.delivery_fee)
        }}
      </template>

      <template v-slot:item.delivery_address="{ item }">
        <div
          v-if="item.delivery_address"
          class="text-decoration-underline"
          style="cursor: pointer"
          @click="
            () => {
              deliveryDetails = item.delivery_address;
              deliveryDialog = true;
            }
          "
        >
          <v-icon color="secondary" v-text="icons.mdiMapMarker"></v-icon>
          {{ translations.deliveryDetails[lang] }}
        </div>

        <span v-else>
          <v-icon color="secondary" v-text="icons.mdiMapMarker"></v-icon>
          {{ translations.pickupFromStore[lang] }}
        </span>
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at || '-' }}
        <!-- {{ !!item.created_at&&(new Date(item.created_at).toISOString()).replace('T',' ').substring(0,19) }} -->
      </template>

      <template v-slot:item.clearer="{ item }">
        <div>
          {{
            item.transaction_status_id === 8
              ? '-'
              : item.clearer
                ? item.clearer
                : translations.cash[lang]
          }}
        </div>
      </template>

      <template v-slot:item.transaction_status_name="{ item }">
        <v-alert
          v-if="item.transaction_status_id === 3"
          type="success"
          :color="item.refunded ? 'blue' : ''"
          dense
          class="mb-0 text-center"
        >
          <span class="mr-6 subtitle-2">{{
            item.refunded ? translations.refunded[lang] : translations.verified[lang]
          }}</span>
        </v-alert>
        <v-sheet v-else>
          <!-- <b-select
                            v-model="item.transaction_status_id"
                            :items="transactionStatuses"
                            :loading="item.loading"
                            item-text="name"
                            item-value="transaction_status_id"
                            class="mb-3"
                            @change="changeStatus(item)"
                            disabled
                        >
                            <template v-slot:prepend-inner>
                                <div
                                    v-if="item.transaction_status_id === 1"
                                    class="pt-1 mr-1"
                                >
                                    <img src="@/assets/clock.png" width="20" />
                                </div>
                                <div
                                    v-else-if="item.transaction_status_id === 2"
                                    class="pt-1 mr-1"
                                >
                                    <img src="@/assets/flag.png" width="20" />
                                </div>
                            </template>
                        </b-select> -->
          <img src="@/assets/clock.png" width="20" v-if="item.transaction_status_id === 1" />
          <img src="@/assets/flag.png" width="20" v-if="item.transaction_status_id === 2" />
          {{ item.transaction_status_name }}
        </v-sheet>
      </template>

      <!-- <template v-slot:item.actions="{ item }">
                    <v-btn
                        v-if="item.transaction_status_id === 2"
                        color="grey lighten-2"
                        class="text-capitalize my-1 red--text"
                        width="83"
                        depressed
                        @click="
                            () => {
                                transactionId = item.transaction_id;
                                dialog = true;
                            }
                        "
                        >{{ translations.refund[lang] }}</v-btn
                    >
                    <v-btn
                        v-else-if="isSuperAdmin"
                        color="grey lighten-2"
                        class="text-capitalize my-1 red--text"
                        width="83"
                        depressed
                        @click="
                            () => {
                                transactionId = item.transaction_id;
                                cancelDialog = true;
                            }
                        "
                        >{{ translations.cancel[lang] }}</v-btn
                    >
                    <v-btn
                        v-if="item.transaction_status_id === 2"
                        color="grey lighten-2"
                        class="text-capitalize my-1 green--text"
                        width="83"
                        depressed
                        @click="
                            () => {
                                item.transaction_status_id = 3;
                                changeStatus(item);
                            }
                        "
                        >{{ translations.verify[lang] }}</v-btn
                    >
                </template> -->
    </v-data-table>
  </b-card>
</template>

<script>
import { mdiClose } from '@mdi/js';

import validators from '@/utils/validators/loyaltyPanel/customers';
import debounce from 'lodash/debounce';
import translations from '@/utils/translations/storePanel/transactions';
// import translations from "@/utils/translations/loyaltyPanel/customers";
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ExportLinks from '@/components/general/ExportLinks.vue';

export default {
  name: 'UserMergeDialog',
  components: { ExportLinks },
  mixins: [validators, translations],
  data: () => ({
    icons: { mdiClose },
    page: 1,
    search: '',
    options: {},
    filtersData: {
      order: ['date', 'desc'],
    },
  }),

  computed: {
    ...mapState(['loading', 'superUser', 'errorMessage']),

    ...mapGetters('loyaltyPanel/customers', [
      'transDialogUserAccId',
      'transDialogUserId',
      'userTransactions',
      'userTransItemsLength',
    ]),
    // transDialogUserId() {
    //     return this.userTransactions[0]?.user_id;
    // },
    lang() {
      return this.$route.params.lang;
    },

    query() {
      let query = '?page=' + this.page;

      // for (let key in this.$route.query) {
      //     query += `${key}=${this.$route.query[key]}&`;
      // }
      if (this.search) {
        query += `&q=${this.search}`;
      }
      return query;
      // .slice(0, query.length - 1);
    },

    headers() {
      return [
        {
          text: 'Id',
          value: 'transaction_id',
          width: 30,
        },
        {
          text: this.translations.user[this.lang],
          value: 'user_identity',
        },
        {
          text: this.translations.store[this.lang],
          value: 'store.name',
        },
        {
          text: this.translations.points[this.lang],
          value: 'total_points',
        },
        {
          text: this.translations.totalAmount[this.lang],
          value: 'total_amount',
        },
        {
          text: this.translations.reason[this.lang],
          value: 'payment_data',
        },
        {
          text: this.translations.deliveryFee[this.lang],
          value: 'delivery_fee',
        },
        {
          text: this.translations.delivery[this.lang],
          value: 'delivery_address',
          width: 120,
        },
        {
          text: this.translations.date[this.lang],
          value: 'created_at',
        },
        // {
        //     text: this.translations.showDetails[this.lang],
        //     value: "show_details",
        //     width: 70,
        // },
        {
          text: this.translations.clearer[this.lang],
          value: 'clearer',
          width: 100,
        },
        {
          text: this.translations.status[this.lang],
          value: 'transaction_status_name',
          width: 190,
        },
        // {
        //     text: this.translations.actions[this.lang],
        //     value: "actions",
        // },
      ];
    },
    sendingData() {
      return {
        query: this.query,
        filters: this.filtersData,
      };
    },
  },
  methods: {
    ...mapMutations('loyaltyPanel/customers', ['setUserTransactions']),
    ...mapActions('loyaltyPanel/customers', ['loadUserTransactions']),

    getFilteredData() {
      this.loadUserTransactions(this.sendingData);
    },
    handleSearch() {
      this.loadUserTransactions(this.sendingData);
    },
  },
  watch: {
    search(val, oldVal) {
      if (val != oldVal) {
        this.page = 1;
      }
      if (val == null) {
        this.getFilteredData();
      } else {
        this.debouncedSearch();
      }
    },
    transDialogUserAccId: {
      handler(val, oldVal) {
        this.setUserTransactions([]);
        this.page = 1;
        this.search = '';
        this.filtersData = {
          order: null,
        };
        this.getFilteredData();
      },
    },

    page(page) {
      this.getFilteredData();
    },
    options: {
      handler(val, oldVal) {
        if (val.sortBy[0]) {
          this.filtersData.order = val.sortBy[0].split('[')[0];
          if (this.filtersData.order === 'created_at') this.filtersData.order = 'date';
          if (val.sortDesc) {
            this.filtersData.order += ',' + (val.sortDesc[0] ? 'desc' : 'asc');
          }

          if (oldVal.sortDesc[0] === undefined || oldVal.sortDesc[0] !== val.sortDesc[0]) {
            if (this.page !== 1) {
              this.page = 1;
            } else {
              this.getFilteredData();
            }
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
  mounted() {
    this.getFilteredData();
  },
};
</script>
